import { VennGroup } from 'src/app/shared/models/domain/venngroup';
import { DesignWrapper } from 'src/app/modules/design/design.wrapper';
import { Venn_Grp } from '../models/domain/venn_grp';
import { TransformWrapper } from 'src/app/modules/design/transforms/transform.wrapper';

export class VennGroupsUtil {
    private static instance: VennGroupsUtil;

    static getInstance() {
        if (!VennGroupsUtil.instance) {
            VennGroupsUtil.instance = new VennGroupsUtil();
        }
        return VennGroupsUtil.instance;
    }

    /**
     * VennGroupsUtil is a singleton class, so use VennGroupsUtil.getInstance() method instead of creating new VennGroupsUtil().
     */
    private constructor() {

    }

    getVennGroup(venn_Grp_Id: number, vennGroups: Array<VennGroup>): VennGroup {
        for (let i: number = 0; i < vennGroups.length; i++) {
            if (vennGroups[i].venn_Grp.venn_Grp_Id == venn_Grp_Id)
                return vennGroups[i];
        }

        return null;
    }

    updateGrpNm(venn_Grp: Venn_Grp, transform_Id: number, designWrapper: DesignWrapper): void {
        let transformWrapper: TransformWrapper = designWrapper.getTransformWrapper(transform_Id);
        if (!transformWrapper) {
            venn_Grp.grpNm = "";
            return;
        }

        venn_Grp.grpNm = transformWrapper.name;
    }

    resetSrt_Order(vennGroups: Array<VennGroup>): void {
        for (let i: number = 0; i < vennGroups.length; i++) {
            vennGroups[i].venn_Grp.srt_Order = i;
        }
    }

    copy(vennGroupsTmp: Array<VennGroup>): Array<VennGroup> {
        let vennGroups: Array<VennGroup> = new Array<VennGroup>();

        for (let i: number = 0; i < vennGroupsTmp.length; i++) {
            vennGroups.push(VennGroup.parse(vennGroupsTmp[i]));
        }

        return vennGroups;
    }

    copyFrom(vennGroups: Array<VennGroup>, vennGroupsTmp: Array<VennGroup>): void {
        let vennGroupsMap: Map<number, VennGroup> = new Map<number, VennGroup>();

        for (let i: number = 0; i < vennGroups.length; i++) {
            let vennGroup: VennGroup = vennGroups[i];
            vennGroupsMap.set(vennGroup.venn_Grp.venn_Grp_Id, vennGroup);
        }

        vennGroups.splice(0, vennGroups.length);

        for (let i: number = 0; i < vennGroupsTmp.length; i++) {
            let vennGroupTmp: VennGroup = vennGroupsTmp[i];

            let vennGroup: VennGroup = vennGroupsMap.get(vennGroupTmp.venn_Grp.venn_Grp_Id);
            if (vennGroup) {
                vennGroup.copyFrom(vennGroupTmp);
            } else {
                vennGroup = VennGroup.parse(vennGroupTmp);
            }

            vennGroups.push(vennGroup);
        }
    }

    compare(vennGroups: Array<VennGroup>, vennGroupsTmp: Array<VennGroup>): string {
        let vennGroupsLength = vennGroups.length;
        let vennGroupsTmpLength = vennGroupsTmp.length;

        if (vennGroupsLength != vennGroupsTmpLength) {
            return 'venn_Grp_Attrs length is different.';
        }

        for (let i: number = 0; i < vennGroupsLength; i++) {
            if (vennGroups[i].compare(vennGroupsTmp[i]) != '') {
                return 'vennGroups [' + i + '] is not equal.'
            }
        }

        return '';
    }

    toString(vennGroups: Array<VennGroup>): string {
        let str: string = '';

        str += 'vennGroups length: ' + vennGroups.length + ' ';

        for (let i: number = 0; i < vennGroups.length; i++) {
            str += vennGroups[i].toString();
        }

        return str;
    }

}